<template>
  <div class="task-allocation-rules">
    <el-card>
      <template #header>
        <div class="card-header">
          <span>任务分配规则管理（强制还款核心）</span>
          <el-tag type="success">100元任务 → 60生活费 + 30还债 + 10平台</el-tag>
        </div>
      </template>
      
      <el-alert type="info" :closable="false" style="margin-bottom: 20px">
        <template #title>
          <strong>债中和核心理念</strong>：系统自动分配，用户无法干预，解决"有钱不还"问题
        </template>
      </el-alert>

      <el-table :data="rules" border stripe>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="taskSource" label="任务来源" width="120">
          <template #default="{ row }">
            <el-tag>{{ taskSourceMap[row.taskSource] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="债务人收入" width="150">
          <template #default="{ row }">
            <el-progress :percentage="row.debtorIncomePercent" :color="'#67c23a'" />
            <span>{{ row.debtorIncomePercent }}% → 现金分</span>
          </template>
        </el-table-column>
        <el-table-column label="自动还债" width="150">
          <template #default="{ row }">
            <el-progress :percentage="row.debtRepaymentPercent" :color="'#e6a23c'" />
            <span>{{ row.debtRepaymentPercent }}% → 解债分</span>
          </template>
        </el-table-column>
        <el-table-column label="平台服务费" width="150">
          <template #default="{ row }">
            <el-progress :percentage="row.platformFeePercent" :color="'#f56c6c'" />
            <span>{{ row.platformFeePercent }}% → 平台收入</span>
          </template>
        </el-table-column>
        <el-table-column prop="isActive" label="状态" width="80">
          <template #default="{ row }">
            <el-tag :type="row.isActive ? 'success' : 'danger'">
              {{ row.isActive ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card style="margin-top: 20px">
      <template #header>
        <span>分配计算器</span>
      </template>
      
      <el-form :inline="true" :model="calcForm">
        <el-form-item label="任务类型">
          <el-select v-model="calcForm.taskType" placeholder="请选择">
            <el-option label="平台任务" value="platform" />
            <el-option label="每日任务" value="daily" />
            <el-option label="商户任务" value="merchant" />
            <el-option label="债权人指定" value="creditor" />
          </el-select>
        </el-form-item>
        <el-form-item label="任务金额">
          <el-input-number v-model="calcForm.amount" :min="1" :max="10000" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="calculateAllocation">计算</el-button>
        </el-form-item>
      </el-form>

      <div v-if="calcResult" style="margin-top: 20px">
        <el-descriptions title="分配结果" :column="3" border>
          <el-descriptions-item label="总金额">
            {{ calcResult.totalAmount }}元
          </el-descriptions-item>
          <el-descriptions-item label="债务人收入">
            <el-tag type="success">{{ calcResult.allocation.debtorIncome.amount }}元 (现金分)</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="自动还债">
            <el-tag type="warning">{{ calcResult.allocation.debtRepayment.amount }}元 (解债分)</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="平台服务费">
            <el-tag type="danger">{{ calcResult.allocation.platformFee.amount }}元</el-tag>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { taskAllocationApi } from '@/api/modules/debt-neutralization';
import { ElMessage } from 'element-plus';

const rules = ref([]);
const calcForm = ref({
  taskType: 'platform',
  amount: 100,
});
const calcResult = ref(null);

const taskSourceMap = {
  platform: '平台任务',
  daily: '每日任务',
  merchant: '商户任务',
  creditor: '债权人指定',
};

const loadRules = async () => {
  try {
    const res = await taskAllocationApi.getRules();
    if (res.code === 200) {
      rules.value = res.data.rules;
    }
  } catch (error) {
    ElMessage.error('加载规则失败');
  }
};

const calculateAllocation = async () => {
  try {
    const res = await taskAllocationApi.calculate(calcForm.value);
    if (res.code === 200) {
      calcResult.value = res.data;
      ElMessage.success('计算成功');
    }
  } catch (error) {
    ElMessage.error('计算失败');
  }
};

onMounted(() => {
  loadRules();
});
</script>

<style scoped>
.task-allocation-rules {
  padding: 20px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
